import { ReactNode } from 'react'

interface ReviewLineProps {
  children: ReactNode
  index: number
  value: string
}

const ReviewLine = ({ children, index, value }: ReviewLineProps) => {
  return (
    <li
      key={`${index}-${value}`}
      className="flex flex-col justify-between items-start w-full "
    >
      <div className="flex flex-col w-full">
        <span className="text-imovGray w-full text-xs md:text-sm md:font-semibold pt-2 md:pl-2">
          {value}
        </span>
        <div>{children}</div>
      </div>
    </li>
  )
}

export default ReviewLine
